import React from 'react';
import { SparklesIcon, CheckCircleIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="py-12 md:py-20 px-4" data-id="element-97">
      <div className="container mx-auto max-w-6xl" data-id="element-98">
        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-99">
          <div className="md:w-1/2 space-y-6" data-id="element-100">
            <div className="inline-block bg-pink-100 text-pink-800 px-4 py-1 rounded-full text-sm font-medium" data-id="element-101">
              <SparklesIcon className="h-4 w-4 inline mr-1" data-id="element-102" />
              Curso + Ebook + Kit Digital
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight" data-id="element-103">
              Nail Masterclass Pro
            </h1>
            <h2 className="text-xl md:text-2xl font-medium text-gray-700" data-id="element-104">
              De Principiante a Nail Artist Profesional
            </h2>
            <p className="text-lg md:text-xl font-semibold text-gray-700" data-id="element-105">
              Conviértete en la técnica de uñas más solicitada de tu zona en
              solo 30 días
            </p>
            <div className="bg-white p-4 rounded-lg shadow-md border border-pink-100" data-id="element-106">
              <p className="text-gray-700 mb-2" data-id="element-107">
                <CheckCircleIcon className="h-5 w-5 text-pink-500 inline mr-2" data-id="element-108" />
                Ebook completo con 6 bonos de regalos
              </p>
              <p className="text-gray-700 mb-2" data-id="element-109">
                <CheckCircleIcon className="h-5 w-5 text-pink-500 inline mr-2" data-id="element-110" />
                Masterclass paso a paso
              </p>
              <p className="text-gray-700" data-id="element-111">
                <CheckCircleIcon className="h-5 w-5 text-pink-500 inline mr-2" data-id="element-112" />
                Kit de herramientas digitales incluido
              </p>
            </div>
            <a href="https://nailmasterclasspro.mitiendanube.com/checkout/v3/start/1789839156/b96e63bc245079acd7af9657978acace71d015a6?from_store=1&country=AR" className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 w-full md:w-auto inline-block text-center" data-id="element-113">
              QUIERO COMENZAR AHORA - $14.999
            </a>
          </div>
          <div className="md:w-1/2" data-id="element-114">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vh5CcYMvswWPXApuaceZF6/Generated_Image_September_15%2C_2025_-_5_21PM.png" alt="Nail art profesional" className="rounded-lg shadow-2xl w-full h-auto" data-id="element-115" />
          </div>
        </div>
      </div>
    </section>;
}